import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "app/service/common/common.service";
import { AuthService } from "../../../service/auth/auth.service";
import { HeyBoard } from "../../../service/board/board";
import { BoardService } from "../../../service/board/board.service";
import { GtmService } from "../../../service/gtm/gtm.service";
import { ImageUploadService } from "../../../service/image/image.service";
import { QuillConfigService } from "../../../service/quill/quill.service";

@Component({
  selector: 'app-hey-detail',
  templateUrl: './hey-detail.component.html',
  styleUrls: ['./hey-detail.component.scss'],
  providers: [BoardService, QuillConfigService, ImageUploadService, DatePipe]
})
export class HeyDetailComponent implements OnInit {
  updating: boolean = false;
  board: HeyBoard;
  id: number;
  url: string;

  constructor(private boardService: BoardService,
    private authService: AuthService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GtmService,
    private quillService: QuillConfigService,
    private imageService: ImageUploadService,
    private datePipe: DatePipe) {

    this.url = location.href;

    this.getKeyword();

    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;

      if (this.id) {
        this.boardService.getByHey(this.id).subscribe(
          board => {
            this.updating = this.router.url.indexOf('edit') != -1;
            this.board = board;

            if (board.location) {
              this.board.location = board.location.key;
              this.board.locationName = board.location.name;
            }
            else this.board.location = '';
            this.tags = this.board.tags.join(' ');
            this.keywords.map(o => {
              this.tags = this.tags.replace(o, '')
            })

            if (this.board.author.email != this.authService.getEmail() && !this.authService.isAdmin()) {
              this.router.navigateByUrl('/member/community');
            }
          }
        );
      } else {
        this.updating = true;
        this.board = new HeyBoard();
        this.board.location = '';
        this.board.prefix = '';

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '글쓰기',
          'breadcrumb': 'Home > Member > Hey!'
        });
      }
    });
  }

  ngOnInit() {
  }

  keywords: string[];
  getKeyword() {
    this.boardService.getHeyKeyword().subscribe(
      ({ keywords }) => this.keywords = keywords
    )
  }

  tags: string;
  onUpdate(board: HeyBoard, tmp: boolean = false) {
    if (this.id) board.id = this.id;
    if (board.location === '') delete board.location
    else board.location = board.location = { key: board.location }
    board.status = tmp ? "TEMP" : "OPEN";
    if (this.tags) board.tags = this.tags.replace(/[ \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\(\=]/gi, ' ').split(' ').filter(str => str.trim().length);

    if (!board.title) {
      window.alert('제목을 입력해 주세요.');
      return;
    } else if (!board.prefix) {
      window.alert('말머리를 선택해 주세요.');
      return;
    } else if (!board.content) {
      window.alert('내용을 입력해 주세요.');
      return;
    }

    if (board.tags) board.tags.unshift(board.prefix)
    else board.tags = [board.prefix]

    let thum = board.content.match(/<img[^>]*src=[\"']?([^>\"']+)[\"']?[^>]*>/)
    if (thum) board.thumbnail = thum[1]

    this.boardService.saveByHey(board).subscribe(
      res => {
        if (this.id) {
          if (board.status === "OPEN") {
            window.alert('게시물이 수정되었습니다.')
          } else {
            window.alert("임시 게시물이 수정되었습니다.\n임시저장 게시물을 확인하려면 홈페이지 좌측 '내 게시물' 메뉴에서 확인하세요.");
          }
        } else {
          if (board.status === "OPEN") {
            window.alert('게시물이 등록되었습니다.');
          } else {
            window.alert("게시물이 임시저장되었습니다.\n임시저장 게시물을 확인하려면 홈페이지 좌측 '내 게시물' 메뉴에서 확인하세요.");
          }

          this.gtmService.newPostEvent({
            'title': res.title,
            'list': 'Hey!',
            'date': this.datePipe.transform(res.createdDate, 'yyyyMMdd'),
            'author': res.author.nick || res.author.name
          })
        }
        this.router.navigateByUrl('/member/community');
      }
    );
  }
  onDelete() {
    if (window.confirm('삭제 하시겠습니까?')) {
      this.boardService.deleteByBoard(this.id).subscribe(
        board => this.router.navigateByUrl('/member/community')
      );
    }
  }
  onClickUpdate() {
    window.scrollTo(0, 0);
    this.updating = true;
  }
  onClickBack() {
    window.scrollTo(0, 0);
    window.history.back();
  }

  public editor;
  onEditorCreated(quill) {
    this.editor = quill;

    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', this.imageHandler.bind(this));
  }
  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
    Imageinput.classList.add('ql-image');

    Imageinput.addEventListener('change', () => {
      const file = Imageinput.files;
      this.imageService.makeFileRequest('/api/file-uploads', file).then(
        (result) => {
          this.pushImageToEditor(result['filename']);
        },
      )
    });

    Imageinput.click();
  }
  pasteHandler(imageDataUrl, type, imageData) {
    const file = imageData.toFile('paste.png')
    this.imageService.makeFileRequest('/api/file-uploads', [file]).then(
      (result) => {
        this.pushImageToEditor(result['filename']);
      },
    )
  }
  get pasteImageHandler() {
    return this.pasteHandler.bind(this)
  }

  pushImageToEditor(src) {
    const range = this.editor.getSelection(true);
    this.editor.insertEmbed(range.index, 'image', src);
  }


  isMine(email: string): boolean {
    return this.authService.getEmail() == email;
  }

  onCanUpdate(): boolean {
    return !this.updating && !!this.board
      && (this.board.author.email == this.authService.getEmail() || this.authService.isAdmin());
  }

  onLike() {
    if (this.board.likeByMe) {
      this.boardService.unlike(this.board.id).subscribe(
        result => {
          this.board.likeByMe = false;
          this.board.countOfLikes--;
          this.initLikeList = false;
        }
      );
    } else {
      this.boardService.like(this.board.id).subscribe(
        result => {
          this.initLikeList = false;
          this.board.likeByMe = true;
          this.board.countOfLikes++;
          this.gtmService.likeEvent({
            'title': this.board.title,
            'list': 'Hey!',
            'date': this.datePipe.transform(this.board.createdDate, 'yyyyMMdd'),
            'author': this.board.author.nick || this.board.author.name
          });
        }
      );
    }
  }

  initLikeList = false;
  showLikeList = false;
  likeList = []
  onLikeView() {
    if (!this.initLikeList) {
      this.boardService.likelist(this.board.id).subscribe(
        result => {
          this.likeList = result;
          this.initLikeList = true;
          this.showLikeList = result.length ? true : false;
        }
      )
    }

    if (this.likeList.length) this.showLikeList = true;
  }

  showProfile(email: string) {
    this.commonService.addProfileEvent(email);
  }

}



// WEBPACK FOOTER //
// ./src/app/member/hey-board/hey-detail/hey-detail.component.ts